import React, { Component } from 'react';
import { Button, CardBody, Card, Collapse } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { logout } from '../../../Redux/Actions/EndUser/AuthActions';
import { userService, auth } from '../../../services';
import './SideNav.scss';

class SideNav extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            toggler1: false,
            toggler2: false,
            toggler3: false,
            toggler4: false,
            toggler5: false,
            toggler6: false,
			toggler7: false,
			toggler8: false,
            displayName: '',
            permissions: [],
            isAdmin: false,
            isEvent: false,
            isInventory: false,
            isField: false,
            isAccounting: false,
            isMembership: false,
            isSubscription: false,
			isSponsorship: false,
			isDonation: false,
			isOrganization: false
        }
    }

	componentDidMount() {
		this.setMenu();
		this.setPermissions();
		// this.isAdmin = true;
		// this.isEvent = true;
		// this.isInventory = true;
		// this.isField = true;
		// this.isAccounting = true;
		// this.isMembership = true;
		// this.isSubscription = true;
        // this.isSponsorship = true;

        // this.setState({
        //     toggler7: true
        // });
        // this.setState({
        //     toggler7: false
        // });
	}

	logoutClick = this.logoutClick.bind(this);

	toggleActive = (e) => {
		let id = e.target.id;
		this.setState({
			[e.target.id]: !this.state[id]
		});
	};

	setMenu() {
		var userName = auth.getAuthUserEmail();
		this.permissions = auth.getPermissions();
		//console.log('permissions', this.permissions);

		if (userName) {
			userService.getUserProfile(userName).then(({ data }) => {
				var role = data.roles.length ? data.roles[0].toUpperCase() : 'USER';
				if (role.toUpperCase() === 'INTERNAL') role = 'ADMIN';
				this.setState({
					displayName: `${data.firstName} ${data.lastName}`
				});
			});
		}
	}
	setPermissions() {
        return this.permissions.find((element) => {
            //console.log(element, "element");
            if (element.value === 'Admin') {
                this.setState({
                    isAdmin: true
                })
            } else if (element.value === 'Events') {
                this.setState({
                    isEvent: true
                })
            } else if (element.value === 'Accounting') {
                this.setState({
                    isAccounting: true
                })
            } else if (element.value === 'Inventory') {
                this.setState({
                    isInventory: true
                })
            } else if (element.value === 'Membership') {
                this.setState({
                    isMembership: true
                })
            } else if (element.value === 'Subscription') {
                this.setState({
                    isSubscription: true
                })
            } else if (element.value === 'Sponsorship') {
                this.setState({
                    isSponsorship: true
                })
            } else if (element.value === 'Field') {
                this.setState({
                    isField: true
                })
			} else if (element.value === 'Donation') {
				this.setState({
					isDonation: true
				})
			} else if (element.value === 'Organization') {
				this.setState({
					isOrganization: true
				})
			}
		});
	}
	logoutClick(event) {
		logout();
		event.preventDefault();
	}
	render() {
		return (
			<div className="side-nav">
				<div className="side-nav-img">
                    <NavLink to="/"><img src="/images/TSCRA-Logo.png" alt="logo"/></NavLink>
				</div>
				<div className="side-nav-user-info text-center">
					<div>
						<span>{this.state.displayName}</span>
					</div>
					<div className="user-info-btn">
						<button className="btnSecondary btn btn-secondary btn-block" onClick={this.logoutClick}>LOGOUT</button>
					</div>
				</div>
				<div className="side-nav-dash">
                    <div className="side-nav-dash-inner">
                        {this.state.isAccounting ? (
                            <div className="side-nav-dash-item">
                                <Button
                                    color="link"
                                    id="toggler4"
                                    onClick={(e) => this.toggleActive(e)}
                                    className={this.state.toggler4 ? 'active-item' : null}
                                >
                                    ACCOUNTING{' '}
                                    <i className={this.state.toggler4 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
                                </Button>
                                <Collapse isOpen={this.state.toggler4}>
                                    <Card style={{ border: 'none' }}>
                                        <CardBody>
                                            <ul>
												{<li>
                                                    <NavLink activeClassName="nav-link-active" to="/admin/purchaseandrenewals">
                                                        PURCHASE AND RENEWALS
													</NavLink>
                                                </li>}
                                                <li>
                                                    <NavLink activeClassName="nav-link-active" to="/admin/batches">
                                                        BATCHES
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/donations">
														DONATIONS
												</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/orderManagement">
														Merchandise Orders
												    </NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/subscription">
														Magazine SUBSCRIPTIONS
													</NavLink>
												</li>
                                            </ul>
                                        </CardBody>
                                    </Card>
                                </Collapse>
                            </div>
                            ) : (
                            <div />
                        )}
                        {this.state.isMembership || this.isField ? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler5"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler5 ? 'active-item' : null}
								>
									User Management{' '}
									<i className={this.state.toggler5 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler5}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/membership">
														MEMBERSHIPS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/membershipusers">
														USERS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/membershiprequests">
														MEMBER REQUESTS
													</NavLink>
												</li>
												{/*<li>
													<NavLink activeClassName="nav-link-active" to="#">
														ORGANIZATIONS (remove)
													</NavLink>
												</li>*/}
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
						) : (
							<div />
						)}
                        {/*this.state.isOrganization ? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler8"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler8 ? 'active-item' : null}
								>
									ORGANIZATIONS{' '}
									<i className={this.state.toggler8 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler8}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/organization">
														ORGANIZATION
													</NavLink>
												</li>
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
						) : (
							<div />
						)*/}
                        {this.state.isSubscription? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler6"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler6 ? 'active-item' : null}
								>
									Content Management{' '}
									<i className={this.state.toggler6 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler6}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/memberdiscounts">
														DISCOUNTS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/archive">
														Magazine ARCHIVE
												    </NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/events">
														EVENTS
													</NavLink>
												</li>
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
						) : (
							<div />
						)}
                        {this.state.isInventory ? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler2"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler2 ? 'active-item' : null}
								>
									Merchandise{' '}
									<i className={this.state.toggler2 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler2}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/products">
														PRODUCTS
												    </NavLink>
												</li>
											    <li>
												    <NavLink activeClassName="nav-link-active" to="/admin/productTypes">
														PRODUCT CATEGORIES
												    </NavLink>
											    </li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/colors">
														COLORS
												    </NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/sizes">
														SIZES
												    </NavLink>
												</li>
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
						) : (
							<div />
                        )}
                        {/*this.state.isDonation ? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler7"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler7 ? 'active-item' : null}
								>
									DONATIONS <i className={this.state.toggler7 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler7}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
                                            
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
                        ) : (
							<div />
                        )*/}
                        {/*this.state.isEvent ? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler3"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler3 ? 'active-item' : null}
								>
									EVENTS{' '}
									<i className={this.state.toggler3 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler3}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
						) : (
							<div />
						)*/}
                        {this.state.isAdmin ? (
							<div className="side-nav-dash-item">
								<Button
									color="link"
									id="toggler1"
									onClick={(e) => this.toggleActive(e)}
									className={this.state.toggler1 ? 'active-item' : null}
								>
									Roles & Responsibilities{' '}
									<i className={this.state.toggler1 ? 'fas fa-caret-down' : 'fas fa-caret-right'} />
								</Button>
								<Collapse isOpen={this.state.toggler1}>
									<Card style={{ border: 'none' }}>
										<CardBody>
											<ul>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/users">
														STAFF
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/districts">
														DISTRICTS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/regions">
														REGIONS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/groups">
														POSITION GROUPS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/positions">
														POSITIONS
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="nav-link-active" to="/admin/committees">
														COMMITTEES
													</NavLink>
												</li>
											</ul>
										</CardBody>
									</Card>
								</Collapse>
							</div>
						    ) : (
							<div> </div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default SideNav;
